<template>
  <div class="w-full mb-3 flex items-center">
    <div class="flex items-center flex-1">
      <div class="mr-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 text-brand-gray-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
          />
        </svg>
      </div>
      <div>
        <div class="text-md font-semibold text-brand-gray-800 tracking-tight">
          {{ cardTitle }}
        </div>
        <div class="text-sm text-brand-gray-600 tracking-wide">
          {{ cardSubtitle }}
        </div>
      </div>
    </div>

    <div class="flex items-center">
      <button
        class="inline-flex items-center shadow-sm p-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full bg-white hover:border-red-600 transition-all duration-150 text-gray-500 hover:text-red-600"
        @click="removePaymentMethod"
        :disabled="isLoading"
      >
        <XIcon class="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script>
import { XIcon } from '@heroicons/vue/solid'

export default {
  name: 'PaymentMethodRow',
  components: {
    XIcon
  },
  props: {
    paymentMethod: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cardTitle() {
      const brand = this.paymentMethod?.attributes?.brand?.toString() || ''
      const last4 = this.paymentMethod?.attributes?.last4?.toString() || ''
      const capitalizedBrand = brand.charAt(0).toUpperCase() + brand.slice(1)
      return `*${last4} ${capitalizedBrand}`
    },
    cardSubtitle() {
      const expMonth = this.paymentMethod?.attributes?.exp_month
      const expYear = this.paymentMethod?.attributes?.exp_year
      const name = this.paymentMethod?.attributes?.name

      let subtitle = ''
      if (name) {
        subtitle = name + ' · '
      }
      subtitle += `Expires ${expMonth}/${expYear}`
      return subtitle
    }
  },
  methods: {
    removePaymentMethod() {
      this.$emit('remove-payment-method', this.paymentMethod)
    }
  }
}
</script>
